import React, { useState, useEffect } from 'react';
import Sidenav from '../Sidenav/Sidenav';
import AddDeviceModal from '../Devices/AddDeviceModal';
import  DeleteDevice from '../Devices/DeleteDevice'
import { useNavigate } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import api from '../api/api'
import wrong from '../../src/assets/wrong.png'
import { Menu, MenuItem,  } from '@mui/material';
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import correct from '../../src/assets/correct.png'
import Box from '@mui/material/Box';
import { CircularProgress } from "@mui/material";


import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import TabletAndroidRoundedIcon from '@mui/icons-material/TabletAndroidRounded';
import Toast from '../global/toastmessage';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import SideNavLayout from '../Sidenav/SideNavLayout';



const Devicehome = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [currentDevice, setCurrentDevice] = useState(null);
  const [openMenuIndex, setOpenMenuIndex] = useState(null);
  const [devices,setDevices] = useState([])
    const [fullNames, setFullNames] = useState("");
  
   const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [severity, setSeverity] = useState("success");
     const [open, setOpen] = useState(false);
     const [alertMessage, setAlertMessage] = useState("");
  
  const navigate = useNavigate();


  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedDevice, setSelectedDevice] = useState(null);
    
  const handleMenuOpen = (event, device) => {
    setAnchorEl(event.currentTarget);
    setSelectedDevice(device);
  };
  
  
    const handleMenuClose = () => {
      setAnchorEl(null);
    };


  const [toast, setToast] = useState({
    open: false,
    message: '',
    severity: 'success' // 'success', 'error', 'warning', 'info'
  });

  const showToast = (message, severity = 'success') => {
    setToast({
      open: true,
      message,
      severity
    });
  };

  const handleCloseToast = () => {
    setToast(prev => ({ ...prev, open: false }));
  };



  useEffect(() => {
    const fetchDevices = async () => {
      try {
        setLoading(true);
        const response = await api.get("/v1/devices/get");
  
        if (response.data && Array.isArray(response.data)) {
          // Transform id to device_id if needed
          const devicesWithDeviceId = response.data.map(device => ({
            ...device,
            device_id: device.device_id
          }));
          setDevices(devicesWithDeviceId); 
        }
      } catch (error) {
        console.error("Error fetching devices:", error);
      }
      finally {
        setLoading(false);
      }
    };
  
    fetchDevices();
  }, []);




  const toggleMenu = (index) => {
    setOpenMenuIndex(openMenuIndex === index ? null : index);
  };

  const handleEdit = (device) => {
    setCurrentDevice({
      ...device,
      device_id: device.device_id // Ensures device_id is always present
    });
    setIsModalOpen(true);
  };
  

  const handleDelete = (device) => {
    setCurrentDevice(device);
    setIsDeleteModalOpen(true);
    setFullNames(device.device_name);

  };

  const deleteDevice = async () => {
    try {
      if (!currentDevice?.device_id) {
        console.error("No device_id found for deletion.");
        showToast('No device selected for deletion', 'error');
        return;
      }
  
      console.log("Deleting device with ID:", currentDevice.device_id);
  
      await api.delete(`/v1/devices/delete?device_id=${currentDevice.device_id}`);
  
      const response = await api.get("/v1/devices/get");
  
      if (response.data && Array.isArray(response.data)) {
        setDevices(response.data);
      }
  
      setIsDeleteModalOpen(false);
      showToast(response.data?.message || 'Device deleted successfully');
    } catch (error) {
      console.error("Error deleting device:", error);
      console.log("Full error response:", error?.response?.data);
      showToast(error.response?.data?.message || 'Failed to delete device', 'error');
    }
  };
  

  const handleSaveDevice = (responseData, isEditMode) => {
    fetchDevices(); // Refresh the list
    showToast(
      responseData?.message || 
      (isEditMode ? 'Device updated successfully' : 'Device created successfully')
    );
  };



  const fetchDevices = async () => {
    try {
      setLoading(true);
      const response = await api.get("/v1/devices/get");
      
      if (response.data && Array.isArray(response.data)) {
        setDevices(response.data); 
      }
    } catch (error) {
      console.error("Error fetching devices:", error);
      showToast('Failed to load devices', 'error');
    } finally {
      setLoading(false);
    }
  };
  
  
 
  

  return (
         <SideNavLayout>
      <div className='w-full max-h-[calc(100vh-100px)] overflow-y-auto  p-8' style={{scrollbarWidth:'none'}}>
        <div className='flex justify-center items-center mb-6 gap-2'>
          <button onClick={() => navigate('/dashboard')} className='bg-[#145388] flex items-center gap-1 text-white px-3 py-1 rounded-md text-sm font-inter'>
            <HomeRoundedIcon style={{width:"20px"}} /> Home
          </button>
          <button onClick={() => setIsModalOpen(true)} className='bg-[#145388] flex items-center gap-1 text-white px-3 py-1 rounded-md text-sm font-inter'>
            <TabletAndroidRoundedIcon style={{width:"14px"}} /> Add Device
          </button>
        </div>
         {loading ? (
                  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
                    <CircularProgress />
                  </Box>
                ) : error ? (
                  <div className="text-red-500 text-center p-4">Error loading users: {error}</div>
                ) : (
        
<div className='bg-white w-[100%] mx-auto  rounded-lg'>
  <div className='overflow-y-auto max-h-[500px] overflow-x-auto rounded-lg scrollbar-thin border p-4'>
    <table className='w-full table-auto border-collapse'>

          <thead className='bg-gray-200 text-left text-gray-700 uppercase text-m'>
          <tr className='text-xs'>
                <th className='py-3 px-4 font-Font1 font-semibold text-red-800 text-gray-400'>Device</th>
                 <th className='py-3 px-4  font-Font1 font-semibold text-red-800 text-gray-400'>Device ID</th>
                <th className='py-3 px-4  font-Font1 font-semibold text-red-800 text-gray-400'>Device UID</th>
                <th className='py-3 px-4  font-Font1 font-semibold text-red-800 text-gray-400'>Status</th>
                <th className='py-3 px-4  font-Font1 font-semibold text-red-800 text-gray-400'>Action</th>
              </tr>
            </thead>
            <tbody>
              {devices
              .filter(item => item.status === 'A')
              .map((item, index) => (
                <tr key={index} className='even:bg-gray-100 text-gray-700 relative'>
                  <td className='py-2 px-2'  align='left'>
                    <button   onClick={() => {
            handleEdit(selectedDevice);
            handleMenuClose();
          }} className='bg-gray-50 border text-[13px] font-inter text-[#374151] px-3 py-1 rounded-md'>
                           {item.device_name}  <KeyboardArrowRightRoundedIcon fontSize="small" />
                    </button>
                  </td>
                  {/* <td className='py-2 px-2' align='left '>{item.device_uid}</td> */}
                    <td className='py-2 pl-4 text-[13px] font-inter text-[#374151] pr-2' align='left'>{item.serial_id||'-'}</td>
                  <td className='py-2 pl-4 text-[13px] font-inter text-[#374151] pr-2' align='left'>{item.device_uid}</td>

                  <td className='py-2 pl-7 text-center  pr-2' align='left'>
                    {item.status === 'A' ? (
                      <img src={correct} alt="Active" className="h-4 w-4" />
                    ) : (
                      <img src={wrong} alt="Active" className="h-4 w-4" />
                    )}
                  </td>
                  <td className="py-2 px-2" align="left">
                  <button
  onClick={(e) => handleMenuOpen(e, item)}
  className="bg-transparent px-2 text-[13px] font-inter text-[#374151] py-1 rounded-md"
>
  Actions <KeyboardArrowDownRoundedIcon />
</button>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          elevation: 1, // Reduce default elevation
          sx: {
            boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.15)', // Subtle custom shadow
            borderRadius: '8px'
          }
        }}
      >
        <MenuItem style={{fontSize:"14px"}}
          onClick={() => {
            handleEdit(selectedDevice);
            handleMenuClose();
          }}
        >
          <EditIcon style={{color:"gray"}} fontSize="small" className="mr-2" /> Edit
        </MenuItem>
        <MenuItem style={{fontSize:"14px"}}
          onClick={() => {
            handleDelete(selectedDevice);
            handleMenuClose();
          }}
        >
          <DeleteIcon style={{color:"red"}} fontSize="small" className="mr-2" /> Delete
        </MenuItem>
      </Menu>
    </td>
                </tr>
              ))}
            </tbody>
            </table>
  </div>
</div>

       )}

        <AddDeviceModal
          isOpen={isModalOpen}
          onClose={() => {
            setIsModalOpen(false);
            setCurrentDevice(null);
          }}
          deviceData={currentDevice}
          onSave={handleSaveDevice}
          showToast={showToast}
        />

        <DeleteDevice
          isOpen={isDeleteModalOpen}
          onClose={() => setIsDeleteModalOpen(false)}
          onConfirm={deleteDevice}
          deleteConfirm ={fullNames}

        />

<Toast
          open={toast.open}
          onClose={handleCloseToast}
          severity={toast.severity}
          message={toast.message}
        />
      </div>
      </SideNavLayout>
  
  );
};

export default Devicehome;
